// extracted by mini-css-extract-plugin
module.exports = {"custom-filter":"styles_custom-filter__3A6RX"};